import { University } from "@src/domain/universities/entities/university.entity";
import { UniqueEntityID } from "@src/domain/pascos/value_objects/unique_entity_Id";

/**
 * University Mapper
 * Maps between API responses and University domain entities
 */
export class UniversityMapper {
    /**
     * Map API response to University domain entity
     */
    static toDomain(raw: any): University {
        // Helper function to safely parse dates
        const parseDate = (dateValue: any): Date => {
            if (!dateValue) {
                return new Date();
            }
            const parsedDate = new Date(dateValue);
            // Check if date is valid
            if (isNaN(parsedDate.getTime())) {
                return new Date();
            }
            return parsedDate;
        };

        return University.create({
            name: raw.name,
            code: raw.code,
            description: raw.description || null,
            address: raw.address || null,
            website: raw.website || null,
            isActive: raw.is_active,
            createdAt: parseDate(raw.created_at),
            updatedAt: parseDate(raw.updated_at),
        }, new UniqueEntityID(raw.university_id));
    }

    /**
     * Map University domain entity to API persistence format
     */
    static toPersistence(university: University): any {
        return {
            name: university.name,
            code: university.code,
            description: university.description ?? null,
            address: university.address ?? null,
            website: university.website ?? null,
            is_active: university.isActive,
        };
    }

    /**
     * Map University domain entity to API update format
     */
    static toUpdate(university: University): any {
        return {
            name: university.name,
            code: university.code,
            description: university.description ?? null,
            address: university.address ?? null,
            website: university.website ?? null,
            is_active: university.isActive,
        };
    }
}